import React from "react";
import "./Copyright.scss";

const Copyright = () => {


  let year = new Date().getFullYear()


  return (
    <div className="copyright">
      <div className="copyright_info">
        <span>Copyright © {year} APRONS N LOVE. All Rights Reserved.</span>
      </div>
    </div>
  );
};
 
export default Copyright;
